import { render, staticRenderFns } from "./VideoPlayV2.vue?vue&type=template&id=63a84d4f"
import script from "./VideoPlayV2.vue?vue&type=script&lang=js"
export * from "./VideoPlayV2.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayV2.vue?vue&type=style&index=0&id=63a84d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports